<template>
    <div
        class="app-container clearfix"
        v-loading="openloading"
        element-loading-text="加载中"
        element-loading-background="rgba(0, 0, 0, 0.1)"
    >
        <el-row style="padding-bottom: 15px">
            <el-col :span="24">
                <h3 class="headtitle">摘要字段维护</h3>
                <span>摘要字段</span>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="24">
                <el-card>
                    <el-row>
                        <el-col style="padding: 10px 0 20px">
                            <el-button
                                size="mini"
                                type="primary"
                                icon="el-icon-plus"
                                class="pull-right"
                                @click="addInfo"
                                >新增</el-button
                            >
                        </el-col>
                    </el-row>

                    <el-table
                        :data="tableData"
                        size="mini"
                        style="width: 100%; margin-top: 10px"
                        border
                    >
                        <el-table-column label="操作" width="200">
                            <template slot-scope="scope">
                                <el-tooltip content="编辑" placement="bottom">
                                    <el-button
                                        type="primary"
                                        icon="el-icon-edit"
                                        circle
                                        @click="editRow(scope.row)"
                                        size="mini"
                                    ></el-button>
                                </el-tooltip>
                                <el-tooltip content="删除" placement="bottom">
                                    <el-button
                                        type="danger"
                                        icon="el-icon-delete"
                                        circle
                                        @click="deleteEntity(scope.row._id)"
                                        size="mini"
                                    ></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="字段名称">
                            <template slot-scope="scope">{{ scope.row.name }}</template>
                        </el-table-column>
                        <el-table-column prop="type" label="字段编码">
                            <template slot-scope="scope">{{ scope.row.type }}</template>
                        </el-table-column>
                    </el-table>
                    <pagerBar
                        ref="refPagerBar"
                        :apiURL="basicDataListUrl"
                        :GetData="initData"
                        :queryParam="formInLine"
                        :errorFunc="closeOpenloading"
                    ></pagerBar>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog
            v-el-drag-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="40%"
            :before-close="handleClose"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <el-form label-width="110px" :model="formLabel" ref="BasicDataEditForm">
                <el-form-item label="字段名称" prop="name">
                    <el-input
                        placeholder="请输入字段名称"
                        v-model="formLabel.name"
                        class="width100"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label="字段编码" prop="type">
                    <el-input
                        placeholder="请输入字段编码"
                        v-model="formLabel.type"
                        class="width100"
                    >
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="SaveEntity()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import config from "@/common/config.js";
import AjaxHelper from "@/common/js/AjaxHelper";
import pagerBar from "@/views/pager/pagerBar";
export default {
    data() {
        return {
            openloading: true,
            dialogVisible: false, // 弹窗显示
            tableData: [],
            choosedTypes: {},
            lstTypes: [],
            basicDataListUrl: config.BASE_Middle_API + "ExpFields/GetAll",
            basicDataUrl: config.BASE_Middle_API + "ExpFields", //摘要档案
            deleteUrl: config.BASE_Middle_API + "ExpFields/Delete",
            CurrnetIndex: 0,
            title: "新增摘要字段",
            operation: "",
            formLabel: {
                id: null,
                name: "",
                type: 1,
            },
            formInLine: {
                Filter: "",
            },
        };
    },
    components: {
        pagerBar,
    },
    methods: {
        closeOpenloading() {
            this.openloading = false;
        },
        //新增摘要资料档案
        addInfo() {
            this.dialogVisible = true;
            this.clearformLabel();
            this.title = "新增摘要字段";
            this.operation = "add";
        },
        clearformLabel() {
            const _this = this;
            _this.formLabel.name = "";
            _this.formLabel.type = 1;
        },
        //编辑
        editRow(row) {
            const _this = this;
            _this.dialogVisible = true;
            _this.initModel();
            _this.title = "编辑摘要字段";
            _this.operation = "edit";
            _this.formLabel = Object.assign({}, row);
        },
        initModel() {
            if (this.$refs["BasicDataEditForm"]) {
                this.$refs["BasicDataEditForm"].resetFields();
                this.formLabel = {
                    name: "",
                    type: 1,
                };
            }
        },
        deleteEntity(id) {
            const _this = this;
            this.$confirm("此操作将删除该摘要字段, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true,
            })
                .then(() => {
                    let confirmData = { Id: id };
                    AjaxHelper.delete(_this.deleteUrl, confirmData).then(function(response) {
                        if (response.success) {
                            _this.$message({
                                type: "success",
                                message: "删除成功!",
                            });
                            _this.Refresh();
                        }
                    });
                })
                .catch((e) => {
                    _this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        //保存摘要资料档案
        SaveEntity() {
            const _this = this;
            this.$refs["BasicDataEditForm"].validate((valid) => {
                let postUrl = "";
                if (_this.operation == "edit") {
                    postUrl = "/Edit";
                } else {
                    postUrl = "/Add";
                }
                _this.formLabel.tempId = _this.formLabel._id;

                if (valid) {
                    AjaxHelper.post(_this.basicDataUrl + postUrl, _this.formLabel).then(function(
                        response
                    ) {
                        if (response.success) {
                            _this.$message({
                                type: "success",
                                message: "操作成功",
                            });
                            _this.pagesize = 1;
                            _this.Refresh();
                            _this.dialogVisible = !_this.dialogVisible;
                        } else {
                            _this.$message({
                                type: "error",
                                message: response.Messages[0],
                            });
                        }
                    });
                    // .catch(function(error) {
                    //   _this.$message({
                    //     type: "error",
                    //     message: error
                    //   });
                    // });
                }
            });
        },
        initData(d) {
            const _this = this;
            _this.tableData = d;
            _this.openloading = false;
        },
        Refresh() {
            this.$refs.refPagerBar.Refresh();
        },
        handleClose(done) {
            done();
        },
    },
};
</script>

<style scoped="scoped">
dt,
dd {
    margin: 0;
    padding: 0;
}
.el-card {
    height: calc(100vh - 217px) !important;
}
</style>
